
import { ActivimeterDetailDto, CreateActivimeterDetailDto, UpdateActivimeterDetailDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { activimeterDetailService, ActivimeterDetailsFilters } from '@services/activimeterDetailService'

const { reducer, actions, thunks } = baseCrudReducer<
  ActivimeterDetailDto,
  CreateActivimeterDetailDto,
  UpdateActivimeterDetailDto,
  ActivimeterDetailsFilters
>('activimeterDetail', activimeterDetailService)

export default reducer

export const { setFilters: setActivimeterDetailFilters } = actions

export const {
  getAll: getActivimeterDetails,
  create: createActivimeterDetail,
  update: updateActivimeterDetail,
  remove: removeActivimeterDetail,
} = thunks
